import { postDataWithParams } from 'src/consumer/services/profileService'

export async function createNewPracticeTimer({ timerData, clientSessionId }) {
  // const resp = await postDataWithParams(
  //   `/api/secure/add/user/meditations/${timerData?.title}/duration/${timerData?.duration}`,
  //   {},
  //   {
  //     anonymsSessionId: clientSessionId,
  //     bellType: timerData?.bellType,
  //   },
  // )
  // if (resp?.status === 200) {
  //   const otherResp = await postDataWithParams(
  //     `/api/secure/add/meditation/${resp.data.id}/details`,
  //     {
  //       preferredTimes: timerData?.preferredTimes,
  //     },
  //   )
  //   return otherResp
  // } else {
  //   return resp
  // }

  const resp = await postDataWithParams(
    `/api/secure/custom-technique-timer/save`,
    { ...timerData, apiParam: 'technique' },
    { sessionId: clientSessionId },
  )
  return resp
}

// `/api/secure/add/user/meditations/${timerData?.title}/duration/${timerData?.duration}`,
